// extracted by mini-css-extract-plugin
export var children = "ContactSegment-module--children--6efbb";
export var contactItem = "ContactSegment-module--contactItem--9c617";
export var contactItemContainer = "ContactSegment-module--contactItemContainer--c012c";
export var container = "ContactSegment-module--container--ad93c";
export var primary = "ContactSegment-module--primary--8df43";
export var primaryActive = "ContactSegment-module--primary--active--5e44e";
export var secondary = "ContactSegment-module--secondary--fb43d";
export var title = "ContactSegment-module--title--f3791";